export class AssessmentQuestionRequest {
    public AssessmentTypeId : number;
}

